const GOOGLE_SCRIPT_SRC = 'https://accounts.google.com/gsi/client';
export function injectGoogleScript(
  doc: Document = typeof document !== 'undefined' ? document : undefined as never,
): HTMLScriptElement {
  if (!doc) {
    throw new Error('injectGoogleScript: 当前环境不存在 document');
  }

  const existing = doc.querySelector<HTMLScriptElement>(`script[src="${GOOGLE_SCRIPT_SRC}"]`);
  if (existing) {
    return existing;
  }

  const target = doc.head ?? doc.body;
  if (!target) {
    throw new Error('injectGoogleScript: 无法找到可插入脚本的节点');
  }

  const script = doc.createElement('script');
  script.src = GOOGLE_SCRIPT_SRC;
  script.async = true;
  script.defer = true;

  target.appendChild(script);
  return script;
}
